export default __webpack_public_path__ + "static/media/inbound_calls.03b13a3d.svg";